import { Box, Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import colors from '../../constants/colors'
import { AppDispatch } from '../../store'
import reportsSelector from '../../store/reports/reportsSelectors'
import { getQuestionsForArrayOfTypes } from '../../store/reports/reportsSlice'
import textUtils from '../../utils/textUtils'
import Chips from '../Chips'
import { IOptionItem } from '../Dropdown/types'
import constants from './constants'

const ReportSubheader: React.FC = () => {
  const [selectedTypes, setSelectedTypes] = useState<IOptionItem[]>([])
  const selectedCase = useSelector(reportsSelector.selectedReport)
  const selectedReportTypes = useSelector(reportsSelector.reportCaseTypes)
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    if (selectedReportTypes) {
      const caseTypes = selectedReportTypes.map(obj => ({
        label: textUtils.humanize(obj.text),
        value: obj.text,
      }))
      // console.log(caseTypes)
      setSelectedTypes(caseTypes)
      dispatch(
        getQuestionsForArrayOfTypes({
          caseTypes: [...(caseTypes.map(type => type?.value) as string[])],
        }),
      )
    }
  }, [selectedReportTypes])

  return (
    <Box className={'t-page-subheader'}>
      <Stack width='12%' sx={[constants.rightBorderStyle, constants.itemStyle]}>
        <Typography variant='labelBold'>Case Number</Typography>
        <Typography variant='bodyBold'>{selectedCase?.case_number}...</Typography>
      </Stack>
      <Stack width='30%' sx={[constants.rightBorderStyle, constants.itemStyle]}>
        <Typography variant='labelBold'>Case Name</Typography>
        <Typography variant='bodyBold'>{selectedCase?.name}</Typography>
      </Stack>
      <Stack width='58%' sx={[constants.itemStyle]}>
        <Box sx={[{ width: '100%', display: 'flex', alignItems: 'center', gap: '1rem' }]}>
          <Typography variant='bodyBold' color={colors.TAG_BLUE} sx={{ whiteSpace: 'nowrap' }}>
            Case Types:
          </Typography>

          <Chips values={selectedTypes} />
        </Box>
      </Stack>
    </Box>
  )
}

export default ReportSubheader
